import React from 'react';

const cards = [
  {
    title: "AI 인프라 확산",
    desc: "AI 시스템이 클라우드, 서버, 네트워크 등 다양한 환경에서 운영되며 보안 취약점이 더욱 복잡하고 광범위하게 증가하고 있습니다.",
  },
  {
    title: "리눅스 서버의 중요성",
    desc: "AI · 데이터 서비스의 중심 인프라로 리눅스 서버 보안은 체계적인 보안 관리가 필수입니다.",
  },
  {
    title: "신종 위협의 증가",
    desc: "모델 탈취, 데이터 포이즈닝, 자동화된 공격 등 AI 특화 위협이 복잡해지고 있습니다.",
  },
  {
    title: "자동화 기반 대응",
    desc: "실시간 감시 · 이상행동 탐지 등 AI를 활용한 보안 자동화는 운영 효율과 대응 속도를 높입니다.",
  },
];

const SecResearchWhyCards = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>왜 필요한가?</h2>
      <div className={styles.divider} />

      <div className={styles.researchCardGrid}>
        {cards.map((c, idx) => (
          <div className={styles.researchCard} key={idx}>
            <div className={styles.researchCardTitle}>{c.title}</div>
            <div className={styles.researchCardDesc}>{c.desc}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default SecResearchWhyCards